<template lang="html">
    <div id="tutoring"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <navBar :tags="tags" :title="titleName" :subTitle="subTitle"  :btnBack="false" :btnAddPlan="btnAddPlan" :btnAddRecord="btnAddRecord"
                @btnAddPlan="handleAddPlan" @btnAddRecord="handleAddRecord" />
        <div style="width: 100%;height: 300px">
            <el-form label-width="70px" style="padding-top:10px">
                <el-row>
                    <el-row>
                        <el-col :span="12">
                            <span style="display: inline-block;width: 70px;margin-right: 10px;font-weight: bold">协访日期</span>
                            <div style="display: inline-block;width: calc(100% - 120px)">
                                <el-date-picker
                                        v-model="start_time"
                                        type="date"
                                        format="yyyy-M-d"
                                        value-format="yyyy-MM-dd"
                                        placeholder="选择日期"
                                        style="width: 45%"
                                @change="changeDate">
                                </el-date-picker><span style="display: inline-block;width: 10%;text-align: center;">
                                至
                        </span><el-date-picker
                                    v-model="end_time"
                                    type="date"
                                    format="yyyy-M-d"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                    style="width: 45%"
                                    @change="changeDate">
                            </el-date-picker>
                            </div>


                        </el-col>
                        <el-col :span="6" style="text-align: left">
                            <span style="display: inline-block;width: 70px;margin-right: 10px;font-weight: bold">
                                协访人
                            </span>
                            <el-select v-model="coach_id" placeholder="请选择"
                                       style="width: calc(100% - 110px);" clearable>
                                <el-option
                                        v-for="item in optionVisitorList"
                                        :key="item.owner_id"
                                        :label="item.owner_name"
                                        :value="item.owner_id">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="6" style="text-align: center;margin-top: 1px">
                            <div v-if="title === '管理员'" style="display: inline-block;text-align: right;width: 100%">
                          <span style="display: inline-block;width: 70px;margin-right: 10px;font-weight: bold">
                              被协访人
                          </span>
                                <el-select v-model="coachee_id" placeholder="请选择" style="width: calc(100% - 110px)" clearable>
                                    <el-option
                                            v-for="item in optionUnVisitorList"
                                            :key="item.owner_id"
                                            :label="item.owner_name"
                                            :value="item.owner_id">
                                    </el-option>
                                </el-select>

                            </div>

                            <div v-else style="text-align: right;width: 100%">
                            <span style="display: inline-block;width: 70px;margin-right: 10px;font-weight: bold">
                          被协访人
                            </span>
                                <el-select disabled v-model="coachee_id" placeholder="请选择" style="width: calc(100% - 120px)" clearable>
                                    <el-option
                                            v-for="item in optionUnVisitorList"
                                            :key="item.owner_id"
                                            :label="item.owner_name"
                                            :value="item.owner_id">

                                    </el-option>
                                </el-select>
                            </div>

                        </el-col>
                    </el-row>

                    <el-row style="margin-top: 20px">
                        <el-col :span="12">
                        <span  style="margin-right: 10px;display: inline-block;width: 70px;font-weight: bold">
                            协访类型
                        </span>
                            <el-select v-model="coachingType" placeholder="请选择协访类型" style="width: calc(100% - 120px);" clearable>
                                <el-option
                                        v-for="item in optionCoachingTypeList"
                                        :key="item.key"
                                        :label="item.value1"
                                        :value="item.key">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="12" style="text-align: left">
                            <span style="display: inline-block;width: 70px;margin-right: 10px;font-weight: bold;">
                                协访客户
                            </span>
                            <el-autocomplete
                                    style="width: calc(100% - 86px)"
                                    value-key="distributor_name"
                                    popper-class="my-autocomplete"
                                    v-model = "coachingName"
                                    :fetch-suggestions="querySearchAsync"
                                    placeholder="请输入医疗机构、门店或经销商名称"
                                    @select="handleSelectDistributorList">
                                <template slot-scope="props">
                                    <div class="name">
                                        {{ props.item.name }}
                                    </div>
                                </template>
                            </el-autocomplete>
                        </el-col>
                    </el-row>

                    <el-col style="margin-top: 30px">
                            <span style="display: inline-block;width: 70px;margin-right: 10px;font-weight: bold">
                                状态
                            </span>
                            <el-checkbox-group v-model="checkListArray" style="display: inline-block">
                                <el-checkbox label="inplan">计划中</el-checkbox>
                                <el-checkbox label="ongoing">进行中</el-checkbox>
                                <el-checkbox label="beencompleted">已完成</el-checkbox>
                            </el-checkbox-group>

                    </el-col>
                </el-row>
            </el-form>
            <el-row style="margin-top:88px;border-bottom: 2px dotted rgb(231, 234, 236);padding-bottom: 20px;">
                <el-button size="small" type="primary" @click.stop="handleQueryClick">查询</el-button>
                <el-button size="small" type="danger" @click.stop="handleResetClick">重置</el-button>
            </el-row>
        </div>
        <el-table
                :header-cell-style="{'color':'black','font-size':'15px'}"
                :data="tableData"
                border
                style="width: 100%;margin-top: 24px"
                stripe>
            <el-table-column
                    align="center"
                    type="index"
                    label="序号"
                    width="60px">
            </el-table-column>
            <el-table-column
                    prop="activity_date"
                    sortable
                    label="协访日期"
                    width="150px">
            </el-table-column>
            <el-table-column
                    min-width="120"
                    prop="coach_name"
                    sortable
                    label="协访人">
            </el-table-column>
            <el-table-column
                    min-width="120"
                    prop="coachee_name"
                    sortable
                    label="被协访人">
            </el-table-column>
            <el-table-column
                    min-width="120"
                    prop="value1"
                    sortable
                    label="协访类型">
            </el-table-column>
            <el-table-column
                    min-width="120"
                    prop="combinedNum"
                    sortable
                    label="协访客户数">
            </el-table-column>
            <el-table-column
                    min-width="150"
                    prop="confirmed_resultText"
                    sortable
                    label="状态">
                <template slot-scope="scope">
                    <span  :style="{'color':scope.row.color}">{{scope.row.confirmed_resultText}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    label-class-name="weekPlan_table_cell"
                    fixed="right" label="操作"
                    width="80"
                    style="color: #3b99f7"
            >
                <template slot-scope="scope">
                    <div style="width: 100%;text-align: center">
                        <el-button
                                type="warning" size="small"
                                @click="handleDetail(scope.row)">详情
                        </el-button>
                    </div>

                </template>
            </el-table-column>
        </el-table>
        <el-col style="margin-bottom: 20px">
            <pagination :page="page" @changePage="changePageClick"></pagination>
        </el-col>
    </div>
</template>

<script>
import navBar from "../../../components/navBar";
import pagination from "../../../components/pagination";
import moment from "moment";
import http from "../../../APIService/http";
export default {
  name: "medical",
  data() {
    return {
      id: "",
      loading: false,
      tags: ["辖区事务"],
      titleName:
        this.$store.getters.getUser.role === "staff"
          ? this.$store.getters.getUser.alias
          : "所有下属",
      title:
        this.$store.getters.getUser.role === "staff"
          ? this.$store.getters.getUser.alias
          : "管理员",
      subTitle: "辅导/协访",
      tableData: [],
      start_time: "",
      end_time: "",
      page: this.GLOBAL.page_tutoring,
      coachingType: "",
      coachingName: "",
      coachingId: "",
      optionCoachingTypeList: [],
      optionVisitorList: [], //协访人
      optionUnVisitorList: [], //被协访人
      optionCustomer: [],
      checkListArray: [],
      coach_id: "",
      coachee_id: "",
      coacheeSaftt_id: "",
      searchForm: {},
      btnAddRecord: true,
      btnAddPlan: false,
      isStaff: this.$store.getters.getUser.role === "staff",
    };
  },
  components: {
    navBar,
    pagination,
    // Upload
  },
  async created() {
    this.getCoachingTypeList();

    this.getCoVisitorList("COACH");
    this.getAddCoVisitorRole();

    let user = this.$store.getters.getUser;
    if (user.role == "staff") {
      this.btnAddRecord = false;
    }
  },
  mounted() {
    // document.getElementById('main').scrollTo(0, 0)
    if (this.title !== "管理员") {
      this.coachee_id = this.$store.getters.getUser.user_id;
    }
    this.init();
  },
  methods: {
    async getAddCoVisitorRole() {
      let user = this.$store.getters.getUser;
      let data = {
        user_id: user.user_id,
        tenant_id: user.tenant_id,
      };
      await http.post("/wapi/Tutoring/getAddCoVisitorRole", data).then((res) => {
          if(res.data.parameter_value==='T'){
              this.btnAddPlan=true
          }else{
              this.btnAddPlan=false
          }
      });

    },
    changePageClick(page, size) {
      if (page) {
        this.page.current = page;
      }
      if (size) {
        this.page.size = size;
      }
      this.init();
    },
    handleDetail(row) {
      this.GLOBAL.page_tutoring = this.page;
      this.searchForm = row;
      this.$router.push({
        name: "assist",
        params: row,
      });
    },
    async init() {
      let loading = this.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        let user = this.$store.getters.getUser;
        let data = {
          tenant_id: user.tenant_id,
          user_id: user.user_id,
          owner_id: this.coachee_id,
          limit: this.page.size,
          offset: this.page.current - 1,
          start_time: this.start_time ? this.start_time : "",
          end_time: this.end_time ? this.end_time : "",
          coachingType: this.coachingType,
          coachingId: this.coachingId,
          type: this.checkListArray,
          isManage: user.role !== "staff" ? true : false,
          coach_id: this.coach_id,
          coachee_id: this.coachee_id,
          role: user.role,
        };
        // console.log(data)
        await http.post("/wapi/Tutoring/getCoachingList", data).then((res) => {
          if (res.success === true) {
            console.log(res, 11);
            let coachingList = res.data.array;
            this.page.total = res.data.arrayCount.length;
            this.judeg(coachingList);
            loading.close();
          }
        });
      } catch (e) {
        loading.close();
      }
    },
    judeg(arr) {
      let array = arr;
      for (let i = 0; i < array.length; i++) {
        array[i].activity_date = moment(array[i].activity_date).format(
          "YYYY年M月D日"
        );
        array[i].confirmed_resultText = "";
        if (array[i].submitted_date === "") {
          array[i].confirmed_resultText = "计划未提交";
          array[i].color = "red";
        }

        if (
          !(array[i].submitted_date === "") &&
          array[i].confirmed_date === ""
        ) {
          array[i].confirmed_resultText = "计划待确认";
          array[i].color = "#ff9901";
        }

        if (
          !(array[i].confirmed_date === "") &&
          array[i].confirmed_result === "APPROVED"
        ) {
          array[i].confirmed_resultText = "计划已确认";
          array[i].color = "green";
        }

        if (
          !(array[i].confirmed_date === "") &&
          array[i].confirmed_result === "DENIED"
        ) {
          array[i].confirmed_resultText = "计划被拒绝";
          array[i].color = "red";
        }
        if (array[i].completed === "T") {
          array[i].confirmed_resultText = "协访已完成";
          array[i].color = "green";
        }
        if (array[i].confirmed_resultText === "") {
          array[i].confirmed_resultText = "计划进行中";
          array[i].color = "#f5a623";
        }

        // if (array[i].confirmed_result === "APPROVED"){
        //     array[i].confirmed_result = '已完成'
        // }else if (array[i].confirmed_result === "DENIED") {
        //     array[i].confirmed_result = '已拒绝'
        // }else if (array[i].confirmed_result === "") {
        //     array[i].confirmed_result = '待确认'
        // }

        array[i].combinedNum =
          parseInt(array[i].store_num) +
          parseInt(array[i].institutions_num) +
          parseInt(array[i].dealer_num);
      }
      this.tableData = array;
    },
    async querySearchAsync(queryString, cb) {
      var sr = [];
      if (queryString != undefined && queryString.length > 0) {
        let data = {};
        data.tenant_id = this.$store.getters.getUser.tenant_id;
        data.queryString = queryString.trim();
        await http.post("/wapi/Tutoring/getEveryName", data).then((res) => {
          if (res.success === true) {
            // let data = res.data
            // for (let i of data){
            //     i.value = i.institution_name
            // }
            // cb(data)
            cb(res.data);
          }
        });
      } else {
        cb(sr);
      }
    },
    handleSelectDistributorList(item) {
      this.coachingName = item.name;
      this.coachingId = item.id;
    },
    handleQueryClick() {
      this.page = {
        current: 1,
        size: 5,
        total: 0,
      };
      this.init();
    },
    handleResetClick() {
      this.start_time = "";
      this.end_time = "";
      this.coachingType = "";
      this.coachingName = "";
      this.coachingId = "";
      this.coach_id = "";
      if (this.title === "管理员") {
        this.coachee_id = "";
      }
      this.checkListArray = [];
    },
    async getCoachingTypeList() {
      try {
        let user = this.$store.getters.getUser;
        let data = {
          tenant_id: user.tenant_id,
        };
        await http
          .post("/wapi/Tutoring/getCoachingTypeList", data)
          .then((res) => {
            this.optionCoachingTypeList = res.data;
          });
      } catch (e) {}
    },
    changeDate() {
      this.getCoVisitorList("COACH");
    },
    async getCoVisitorList(type) {
      try {
        let user = this.$store.getters.getUser;
        let data = {
          tenant_id: user.tenant_id,
          user_id: user.user_id,
          role: user.role,
          obj: type,
        };
        if (this.start_time) {
          data.month = moment(this.start_time).format("YYYY-MM");
        }
        if (this.end_time) {
          data.month = moment(this.end_time).format("YYYY-MM");
        }
        await http.post("/wapi/Tutoring/getCoVisitorList", data).then((res) => {
          this.optionVisitorList = res.data;
          this.getUnCoVisitorList("COACHEE");
        });
      } catch (e) {}
    },
    async getUnCoVisitorList(type) {
      try {
        let user = this.$store.getters.getUser;
        let data = {
          tenant_id: user.tenant_id,
          user_id: user.user_id,
          obj: type,
          role: user.role,
        };
        if (this.start_time) {
          data.month = moment(this.start_time).format("YYYY-MM");
        }
        if (this.end_time) {
          data.month = moment(this.end_time).format("YYYY-MM");
        }
        await http.post("/wapi/Tutoring/getCoVisitorList", data).then((res) => {
          this.optionUnVisitorList = res.data;

          if (user.role == "staff") {
            this.coachee_id = this.$store.getters.getUser.user_id;
            this.optionUnVisitorList.push({
              owner_name: user.alias,
              owner_id: user.user_id,
            });
          }
        });
      } catch (e) {}
    },
    handleAddRecord() {
      let row = {
        type: "new",
        addType: "record",
      };
      this.$router.push({
        name: "assist",
        params: row,
      });
    },
    handleAddPlan() {
      let row = {
        type: "new",
        addType: "plan",
      };
      this.$router.push({
        name: "assist",
        params: row,
      });
    },
  },
  updated() {},
  beforeRouteLeave(to, from, next) {
    // 打开详情页（或者下一个任意界面）之前，把筛选条件保存到localStorage，如果离开列表页并且打开的不是详情页则清除，也可以选择不清除
    if (to.name === "assist" && to.params.type != "new") {
      // console.log(this.searchForm)
      let condition = JSON.stringify(this.searchForm);
      localStorage.setItem("condition", condition);
    } else {
      localStorage.removeItem("condition");
    }
    if (to.name !== "assist") {
      this.GLOBAL.page_tutoring = {
        current: 1,
        size: 5,
        total: 0,
      };
    }
    next();
  },
};
</script>

<style scoped>
/*#container {*/
/*    background: #fff;*/
/*    padding: 0px 50px;*/
/*    height: 100%;*/
/*    box-sizing: border-box;*/
/*}*/
#tutoring >>> .el-form-item__label {
  font-size: 16px;
  color: #000000;
  padding-left: 0px;
  text-align: left;
  padding-right: 40px;
}

#tutoring >>> .el-table th {
  padding: 7px 0px;
}
#tutoring >>> .el-table td {
  padding: 7px 0px;
}

#tutoring >>> .el-button--warning {
  color: #fff;
  background-color: #ff9901;
  border-color: #ff9901;
}
#tutoring >>> .el-button--warning:hover {
  background: #ebb563;
  border-color: #ebb563;
  color: #fff;
}
#tutoring >>> .el-button {
  font-size: 13px;
}
</style>
<style>
#tutoring .el-form-item__label {
  padding-right: 0 !important;
  font-weight: bold;
}
</style>




// WEBPACK FOOTER //
// src/pages/calendar/components/tutoring.vue